import { render, staticRenderFns } from "./floatView.vue?vue&type=template&id=71067f28"
import script from "./floatView.vue?vue&type=script&lang=js"
export * from "./floatView.vue?vue&type=script&lang=js"
import style0 from "./floatView.vue?vue&type=style&index=0&id=71067f28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d97cc52897b1b5edd1ee8818c6a75fc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports